export enum RightNavType {
  CHAT = "chat",
  NOTIFICATIONS = "notifications",
}
